export const cookieNames = ['mobileApp', 'mobileAppMode', 'mobileAppVersion'] as const;

type PropertyNames = typeof cookieNames[number];

export type MobileCookies = {
  [key in PropertyNames]?: string;
};
